import { render } from "./ServiceDetails5Page.vue?vue&type=template&id=7a6c8bd1&ts=true"
import script from "./ServiceDetails5Page.vue?vue&type=script&lang=ts"
export * from "./ServiceDetails5Page.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__